import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import LockRoundedIcon from '@mui/icons-material/LockRounded';
import GTranslateRoundedIcon from '@mui/icons-material/GTranslateRounded';
import icon from '../../assets/bg-ten-new.svg';

export const Header = styled(Box)`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 576px;
  margin-bottom: 50px;

  img {
    width: 211.418px;
    height: 87.251px;
  }

  @media (max-width: 540px) {
    width: 100%;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 30px;
    img {
      width: 160px;
      height: 67.251px;
    }
  }
`;

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;

  background-image: url(${icon});
  background-size: cover;

  .borderLock {
    width: 3vw;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }

  .title {
    font-family: Roboto;
    font-size: 28px;
    font-weight: 700;
    line-height: 42px;
    letter-spacing: 0.25px;
    text-align: center;

    margin-top: 0;
    margin-bottom: 15px;
  }

  .btn-translate {
    position: absolute;
    right: 0;
    border-color: ${({ theme }) => theme.palette.grey[100]};
    color: ${({ theme }) => theme.palette.grey[100]};
    height: 2.4vw;
    width: 5.18vw;
    font-size: 1.02vw;
    font-weight: 400;
    gap: 9px;
  }

  .header {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    flex-direction: row;
  }

  .form-login {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .submit {
    width: 100%;
    height: 54px;
    display: flex;
    justify-content: center;
    font-size: 1rem;
  }

  .email {
    width: 100%;
  }

  .password {
    width: 100%;
  }

  .check {
    position: relative;
  }

  .section-logar {
    width: 29vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    align-content: center;
    background-color: transparent;
  }

  .line {
    width: 27.34vw;
    background: #e0e0e0;
  }

  .titleLine {
    color: #aaaaaa;
    font-size: 0.85vw;
    margin-left: 10px;
    margin-right: 10px;
  }

  .register-texto {
    color: var(--black, #000);
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    text-decoration-line: underline;
    text-transform: initial;
  }
`;

export const Divider = styled(Box)`
  height: 87.42px;
  width: 1px;
  background-color: #fff;
  @media (max-width: 540px) {
    width: 170.42px;
    height: 1px;
    background-color: #fff;
  }
`;

export const TitleGov = styled(Typography)`
  color: #fff;
  font-family: Montserrat;
  font-size: 29px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  width: 222px;

  @media (max-width: 540px) {
    width: 133px;
    font-size: 17px;
    text-align: center;
  }
`;

export const ContainerSteps = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 576px;
  gap: 10px;
  border-radius: 10px;
  background: var(--white, #fff);
  padding: 50px;

  @media (max-width: 540px) {
    width: 85%;
    padding: 30px 20px 30px 20px;
  }
`;

export const Title = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4caf50;
`;

export const Text = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.15px;
  color: #212121;
  white-space: normal;
  padding: 10px;
`;

export const Div = styled(Box)`
  .formulario-Recover {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 63%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tenmeetings {
    width: 21.37vw;

    position: fixed;
  }

  .title {
    font-size: 24px;
    font-weight: 600;
    position: relative;
    top: 0.5rem;
    margin-top: 0.18rem;
    margin-bottom: 1.2rem;
    color: ${({ theme }) => theme.palette.grey[100]};
  }

  .title-company {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
  }

  .container-input {
    width: 22rem;
  }

  .inputNumber {
    width: 2rem;
    height: 3rem;
    display: flex;
    position: relative;
    text-align: center;
    bottom: 0.4rem;
  }

  .container-confirm {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .btn-confirm {
    left: 0;
    right: 0;
    margin-bottom: 1.25rem;
    width: 6.25rem;
    height: 2.62rem;
  }

  .alert-validation {
    width: 411.8px;
    display: flex;
    justify-content: center;
    margin-top: 1.56rem;
  }
  .contentHeader {
    display: flex;
    justify-content: center;
    align-items: center;

    flex-direction: column;
    gap: 1.87rem;
  }

  .dialog-span {
    text-align: center;
    font-size: 0.93rem;
  }
  .modalTitle {
    font-size: 1.31rem;
    margin-top: 1rem;
  }

  .modal-email {
    margin-top: 3.2rem;
    width: 31.25rem;
  }

  .modal-confirm {
    margin-bottom: 4rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .icon-success {
    margin-top: 3.87rem;
  }

  .message-success {
    margin-top: 2rem;
  }

  h3 {
    font-size: 2.32rem;
  }
  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 63%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon-success {
    margin-top: 3.87rem;
  }

  .message-success {
    margin-top: 2rem;
  }

  h3 {
    font-size: 2.32rem;
  }

  .tenmeetings {
    width: 21.37vw;

    position: fixed;
  }

  .container-input {
    width: 22rem;
  }

  .inputNumber {
    width: 2rem;
    height: 3rem;
    display: flex;
    position: relative;
    text-align: center;
    bottom: 0.4rem;
  }

  .container-confirm {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .btn-confirm {
    left: 0;
    right: 0;
    margin-bottom: 1.25rem;
    width: 6.25rem;
    height: 2.62rem;
  }

  .alert-validation {
    width: 411.8px;
    display: flex;
    justify-content: center;
    margin-top: 1.56rem;
  }
`;

export const LockIcon = styled(LockRoundedIcon)`
  width: 2vw;
  height: 2vw;
  color: ${({ theme }) => theme.palette.grey[100]};
`;

export const Icontranslate = styled(GTranslateRoundedIcon)`
  width: 1.22vw;

  color: ${({ theme }) => theme.palette.grey[100]};
`;

export const ContainerSocialLogin = styled(Box)`
  width: 29vw;
  display: flex;
  flex-direction: row;
  margin-top: 0.7rem;
  gap: 1.56rem;
  justify-content: center;
  Button {
    width: 14.85rem;
    height: 2.6rem;
    font-size: 0.8rvw;
    border-radius: 3px;
    text-transform: none;
    gap: 0.5rem;
    display: flex;
    justify-content: center;
    border-color: #12094d;
    padding: 0;
  }

  img {
    width: 1.43rem;
  }
`;

export const ContainerSubLogin = styled(Box)`
  position: relative;
  top: -6vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 28vw;

  a {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    gap: 0.4rem;
  }
`;

export const DivBackLogin = styled(Box)`
  a {
    text-decoration: none;
    font-size: 1.1vw;
  }
`;

export const CardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 50vh;
  overflow-y: auto;
  padding: 0 10px;
`;

export const Card = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  gap: 20px;
  width: 100%;
  height: 88px;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 6px;
  cursor: pointer;

  img {
    margin-left: 10px;
    width: 5vw;
  }
`;

export const CardTitle = styled(Box)`
  /* width: 100%; */
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  letter-spacing: 0.15px;
  color: #000000;
`;
